export function cartesianToPolar (x, y, z = null){
  if (z === null) {
    return {
      radius: Math.sqrt(x * x + y * y),
      polar: Math.atan2(y, x)
    }
  }
  else {
    const radius = Math.sqrt(x * x + y * y + z * z)
    return {
      radius: radius,
      polar: Math.acos(z/radius),
      azimuth: Math.atan2(y, x)
    }
  }
}